
import React, { useState,useContext } from 'react'
import  LayoutContext  from '../../LayoutContext'
import {SiderLogo}from './SiderLogo'
import {SiderSystem}from './SiderSystem'
import {SiderModule}from './SiderModule'

export const SiderMenu = () =>{
  const { collapsed } = useContext(LayoutContext)

    return (
      <div className="app-index-sider" style={{width: collapsed ? '60px' : '235px'}}>
        <SiderLogo />
        <SiderSystem />
        <SiderModule />
      </div>
    );
}


// WEBPACK FOOTER //
// ./src/layouts/components/SiderMenu/index.tsx